<template>
  <div>
    <h1>{{ $t('login.loginError') }}</h1>
    <v-btn @click="login">
      {{ $t('welcome.button.loginOrRegister') }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'LoginError',

  methods: {
    login() {
      this.$auth.logout()
      this.$auth.login(this.$route.query.redirect || 'Dashboard')
    }
  }
}
</script>
